import React, { useState } from 'react';
import { Card, Button, Modal, Select, Space, Switch, message } from 'antd';
import { SettingOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';

const CustomizableWidget = ({ 
  title, 
  children, 
  widgetKey, 
  onRemove, 
  onSettingsChange,
  availableMetrics = [],
  settings = {}
}) => {
  const [settingsVisible, setSettingsVisible] = useState(false);
  const [localSettings, setLocalSettings] = useState(settings);

  const handleSaveSettings = () => {
    if (onSettingsChange) {
      onSettingsChange(widgetKey, localSettings);
    }
    setSettingsVisible(false);
    message.success('Widget ayarları kaydedildi');
  };

  const handleMetricChange = (selectedMetrics) => {
    setLocalSettings({ ...localSettings, selectedMetrics });
  };

  const handleChartTypeChange = (chartType) => {
    setLocalSettings({ ...localSettings, chartType });
  };

  const handleAutoRefreshChange = (autoRefresh) => {
    setLocalSettings({ ...localSettings, autoRefresh });
  };

  return (
    <>
      <Card
        title={title}
        extra={
          <Space>
            <Button
              type="text"
              icon={<SettingOutlined />}
              size="small"
              onClick={() => setSettingsVisible(true)}
            />
            {onRemove && (
              <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                size="small"
                onClick={() => onRemove(widgetKey)}
              />
            )}
          </Space>
        }
        style={{ height: '100%' }}
      >
        {children}
      </Card>

      <Modal
        title={`${title} - Widget Ayarları`}
        open={settingsVisible}
        onOk={handleSaveSettings}
        onCancel={() => setSettingsVisible(false)}
        okText="Kaydet"
        cancelText="İptal"
      >
        <Space direction="vertical" style={{ width: '100%' }} size="large">
          {availableMetrics.length > 0 && (
            <div>
              <label>Gösterilecek Metrikler:</label>
              <Select
                mode="multiple"
                value={localSettings.selectedMetrics || []}
                onChange={handleMetricChange}
                style={{ width: '100%', marginTop: 8 }}
                placeholder="Metrik seçin"
                maxTagCount={3}
              >
                {availableMetrics.map(metric => (
                  <Select.Option key={metric.value} value={metric.value}>
                    {metric.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
          )}

          <div>
            <label>Grafik Tipi:</label>
            <Select
              value={localSettings.chartType || 'line'}
              onChange={handleChartTypeChange}
              style={{ width: '100%', marginTop: 8 }}
            >
              <Select.Option value="line">Çizgi Grafik</Select.Option>
              <Select.Option value="area">Alan Grafik</Select.Option>
              <Select.Option value="bar">Çubuk Grafik</Select.Option>
              <Select.Option value="pie">Pasta Grafik</Select.Option>
              <Select.Option value="scatter">Dağılım Grafik</Select.Option>
            </Select>
          </div>

          <div>
            <Space>
              <span>Otomatik Yenileme:</span>
              <Switch
                checked={localSettings.autoRefresh || false}
                onChange={handleAutoRefreshChange}
              />
            </Space>
          </div>

          {localSettings.autoRefresh && (
            <div>
              <label>Yenileme Sıklığı:</label>
              <Select
                value={localSettings.refreshInterval || 60}
                onChange={(value) => setLocalSettings({ ...localSettings, refreshInterval: value })}
                style={{ width: '100%', marginTop: 8 }}
              >
                <Select.Option value={30}>30 saniye</Select.Option>
                <Select.Option value={60}>1 dakika</Select.Option>
                <Select.Option value={300}>5 dakika</Select.Option>
                <Select.Option value={600}>10 dakika</Select.Option>
              </Select>
            </div>
          )}

          <div>
            <label>Widget Boyutu:</label>
            <Select
              value={localSettings.size || 'medium'}
              onChange={(value) => setLocalSettings({ ...localSettings, size: value })}
              style={{ width: '100%', marginTop: 8 }}
            >
              <Select.Option value="small">Küçük</Select.Option>
              <Select.Option value="medium">Orta</Select.Option>
              <Select.Option value="large">Büyük</Select.Option>
              <Select.Option value="full">Tam Genişlik</Select.Option>
            </Select>
          </div>
        </Space>
      </Modal>
    </>
  );
};

export const WidgetLibrary = ({ onAddWidget, availableWidgets }) => {
  const [libraryVisible, setLibraryVisible] = useState(false);

  return (
    <>
      <Button
        type="dashed"
        icon={<PlusOutlined />}
        onClick={() => setLibraryVisible(true)}
        style={{ width: '100%', height: '200px' }}
      >
        Yeni Widget Ekle
      </Button>

      <Modal
        title="Widget Kütüphanesi"
        open={libraryVisible}
        footer={null}
        onCancel={() => setLibraryVisible(false)}
        width={800}
      >
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
          gap: '16px'
        }}>
          {availableWidgets.map(widget => (
            <Card
              key={widget.key}
              hoverable
              onClick={() => {
                onAddWidget(widget);
                setLibraryVisible(false);
              }}
              style={{ textAlign: 'center' }}
            >
              <div style={{ fontSize: '32px', marginBottom: '8px' }}>
                {widget.icon}
              </div>
              <h4>{widget.title}</h4>
              <p style={{ fontSize: '12px', color: '#666' }}>
                {widget.description}
              </p>
            </Card>
          ))}
        </div>
      </Modal>
    </>
  );
};

export default CustomizableWidget;